<template>
    <form action="#" @submit.prevent="search">
        <div class="input-group input-group-lg">

            <input name="search" class="form-control input-clear"
                   placeholder="Search by name, email, postcode or event number"
                   v-model="searchValue" v-focus
                   @input="updateSearchDebounced"
                   @keyUp.esc="clearSearch">

            <span class="btn-clear-textbox" v-show="true" @click="clearSearch">
                <i class="fa fa-times"></i></span>

            <span class="input-group-btn">
                    <button class="btn btn-primary" @click.prevent="updateSearch"
                            :disabled="searchInProgress"
                    ><i class="fa fa-search"></i></button>
            </span>
        </div>
    </form>
</template>

<script>
    import { mapMutations, mapState } from 'vuex'

    export default {
        data() {
            return {
                searchValue: '',
                lastSearch: '',
            }
        },

        methods: {
            ...mapMutations(['setSearchQuery']),

            /**
             * Remember search query in session and fire search updated event.
             */
            updateSearch() {
                debug.log('Firing search event: ' + this.searchValue);
                this.lastSearch = this.searchValue;
                this.setSearchQuery(this.searchValue);
            },

            updateSearchDebounced: _.debounce(function () {
                // Only perform automatic searching if the search query is 4 characters or longer
                // and the search query is different to the previous one.
                if (this.searchIsLongEnough() && this.isNewSearch()) {
                    this.updateSearch();
                }
            }, 1000),

            isNewSearch() {
                return this.searchValue !== this.lastSearch;
            },

            searchIsLongEnough() {
                return this.searchValue.length >= 4;
            },

            /**
             * Clear search query and update the search results.
             *
             * @param event
             */
            clearSearch(event) {
                this.searchValue = '';
                this.updateSearch();
            }
        },

        mounted() {
            this.searchValue = this.$store.state.searchQuery;
        },

        computed: {
            ...mapState(['searchInProgress']),
        }
    }
</script>

<style>
    .btn-clear-textbox {
        position: absolute;
        right: 63px;
        top: 6px;
        bottom: 0;
        margin: auto;
        font-size: 20px;
        cursor: pointer;
        color: #ccc;
        z-index: 100;
    }

    .btn-clear-textbox:hover {
        background-color: transparent;
        color: lightgray;
    }

    .input-clear {
        border-right: none;
    }
</style>
